import React from "react";
import styled from "styled-components";

import { Icon } from "js/Components/Icon";

const BreadcrumbContainer = styled.span`
    width: max-content;
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;

export interface LibraryBreadcrumbProps {
    pathParts: string[];
}

export function LibraryBreadcrumb({ pathParts }: LibraryBreadcrumbProps) {
    return (
        <BreadcrumbContainer>
            {pathParts.map((part, i) => (
                <React.Fragment key={`${part}-${i}`}>
                    {i > 0 && <Icon small white>chevron_right</Icon>}
                    <span style={{ textTransform: "capitalize" }}>{part}</span>
                </React.Fragment>
            ))}
        </BreadcrumbContainer>
    );
}
